module.exports = __webpack_public_path__ + "static/media/Ark-Logo-white.8e459854.svg";